import { ReactElement } from 'react';
import NewCampaignKeyDetailsPage from 'pages/campaign/NewCampaignDetails.tsx';
import SelectCampaignTemplatePage from 'pages/SelectCampaignTemplatePage.tsx';
import CampaignDetailsConfirmation from 'pages/campaign/CampaignDetailsConfirmation';
import CampaignLoader from '../components/CampaignLoader';
import PageLayout from '../components/layouts/PageLayout';
import CampaignKeyDetailsPage from '../pages/campaign/CampaignDetails';
import CampaignManagementDetailsPage from '../pages/campaign/ManagementDetails';
import RoutingPlans from '../pages/campaign/RoutingPlans';
import CampaignSummaryPage from '../pages/campaign/Summary';
import createIterationRoutes from './IterationRoutes';

const withCampaignLoader = (component: ReactElement) => (
  <CampaignLoader>{component}</CampaignLoader>
);

const getCampaignChildRoutes = () => [
  { path: '', element: withCampaignLoader(<CampaignSummaryPage />) },
  { path: 'summary', element: withCampaignLoader(<CampaignSummaryPage />) },
  {
    path: 'key-details',
    element: withCampaignLoader(<CampaignKeyDetailsPage />),
  },
  {
    path: 'key-details/confirmation',
    element: withCampaignLoader(<CampaignDetailsConfirmation />),
  },
  {
    path: 'management-details',
    element: withCampaignLoader(<CampaignManagementDetailsPage />),
  },
  { path: 'message-plans', element: withCampaignLoader(<RoutingPlans />) },
  createIterationRoutes(withCampaignLoader),
];

const campaignRoutes = [
  {
    path: ':teamId/campaign/new/template-selection',
    element: <PageLayout />,
    children: [
      {
        path: '',
        element: <SelectCampaignTemplatePage />,
      },
    ],
  },
  {
    path: ':teamId/campaign/new/key-details',
    element: <PageLayout />,
    children: [
      {
        path: '',
        element: <NewCampaignKeyDetailsPage />,
      },
    ],
  },
  {
    path: ':teamId/campaign/:campaignId',
    element: <PageLayout />,
    children: getCampaignChildRoutes(),
  },
];

export default campaignRoutes;
